<template>
    <div id="app">
        <div class="header">
            <div class="logo">Subsfinder</div>
        </div>
        
        <div class="content-wrapper">
            <List/>
        </div>
        <footer>
            Developed by <a href="nourabusoud.com" traget="_blank">Nour Saud</a></footer>
    </div>
</template>

<script>
import List from './components/list.vue'

export default {
    name: 'App',
    components: {
        List
    }
}
</script>

<style>
#app {}
</style>
